import { AjaxHelper, IReadOptions } from '@samc/common';
import { IPriceModel, PriceModelsDatasourcePayload } from '../Interfaces/IPriceModel';
import { CachedDataSource, processQuery } from './BaseDataSources';

/**
 * PortfolioWeb returns `INotificationResult` JSON for `/datasource/pricemodels`; unwrap `result` / `Result` for the dropdown.
 */
function readPriceModelListPayload(data: PriceModelsDatasourcePayload): IPriceModel[] {
  if (Array.isArray(data)) {
    return data;
  }
  if (data === null || data === undefined) {
    return [];
  }
  if (typeof data === 'object') {
    const record = data as Record<string, unknown>;
    if (record['hasErrors'] === true) {
      return [];
    }
    const nested = record['result'] !== undefined ? record['result'] : record['Result'];
    if (Array.isArray(nested)) {
      return nested;
    }
  }
  return [];
}

export class PriceModelSource extends CachedDataSource<IPriceModel> {
  private readonly _helper: AjaxHelper;

  public constructor() {
    super(Number.MAX_SAFE_INTEGER);
    this._helper = new AjaxHelper('/datasource/pricemodels', '', '', null);
  }

  /**
   * New instance + `read()` so the dropdown gets a fresh cache after create, without changing shared {@link CachedDataSource}.
   */
  public static async createLoaded(): Promise<PriceModelSource> {
    const instance = new PriceModelSource();
    await instance.read();
    return instance;
  }

  protected async loadData(options: IReadOptions, abortController: AbortController): Promise<IPriceModel[]> {
    const raw = await this._helper.getData<PriceModelsDatasourcePayload>('', processQuery(options), { signal: abortController.signal });
    return readPriceModelListPayload(raw);
  }
}
